import { calculateWorkOrderCosts } from '@calculations/cost';
import { calculateMarginsFromUnitPrice } from '@calculations/price/utilities/margins';

import { storeToCalculationSnapWorkOrder } from '../../transforms/store-to-calculation-snap-work-order';
import {
  OnQuantityChangeInput,
  OnQuantityChangeOutput,
  OnQuotePriceCreationInput,
  OnQuotePriceCreationOutput,
  OnUnitPriceChangeInput,
  OnUnitPriceChangeOutput,
} from '../types';

/**
 * Pass through function for strategies that do not have side effects on quantity change
 */
export function noOpQuantityChange(
  input: OnQuantityChangeInput,
): OnQuantityChangeOutput {
  if (!input.quoteLine.snapWorkOrder) {
    return {
      status: 'no-op',
    };
  }

  const costs = calculateWorkOrderCosts({
    quantity: input.quantity,
    ...storeToCalculationSnapWorkOrder(input.quoteLine.snapWorkOrder),
  });

  const margins = calculateMarginsFromUnitPrice({
    unitCost: costs.unitCost,
    unitVariableCosts: costs.unitVariableCosts,
    unitPrice: input.quotePrice.unitPrice,
  });

  return {
    status: 'no-op',
    ...margins,
  };
}

/**
 * Pass through function for strategies that do not have side effects on unit price change
 */
export function noOpUnitPrice(
  input: OnUnitPriceChangeInput,
): OnUnitPriceChangeOutput {
  const { quotePrice, unitPrice } = input;

  const margins = calculateMarginsFromUnitPrice({
    unitCost: quotePrice.unitCost,
    unitVariableCosts: quotePrice.unitVariableCosts,
    unitPrice: unitPrice,
  });

  return {
    status: 'no-op',
    ...margins,
  };
}

/**
 * Pass through function for strategies that do not need to calculate new quote prices
 */
export function noOpQuotePriceCreation(
  input: OnQuotePriceCreationInput,
): OnQuotePriceCreationOutput {
  if (!input.quoteLine.snapWorkOrder) {
    return {
      status: 'no-op',
    };
  }

  const costs = calculateWorkOrderCosts({
    quantity: input.quotePrice.quantity,
    ...storeToCalculationSnapWorkOrder(input.quoteLine.snapWorkOrder),
  });

  const margins = calculateMarginsFromUnitPrice({
    unitCost: costs.unitCost,
    unitVariableCosts: costs.unitVariableCosts,
    unitPrice: input.quotePrice.unitPrice,
  });

  return {
    status: 'no-op',
    ...margins,
  };
}
